import React from 'react';
import PropTypes from 'prop-types';

const Logo = ({ name, logo, section }) => {
  const className = section ? `stores-${section}-storeLogo` : 'stores-Logo';
  return (
    <div className={className}>
      <h1>{logo ? <img src={logo} alt={name} /> : name}</h1>
    </div>
  );
};
Logo.propTypes = {
  name: PropTypes.string.isRequired,
  logo: PropTypes.string,
  section: PropTypes.string
};

export default Logo;
